import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

const changeUser = async (uuid: string) => {
  const url = `${import.meta.env.VITE_AUTH_SERVICE_HOST}/v1/admin/users/${uuid}/signin`;

  return request({ url, method: RequestMethod.GET });
};

export const useChangeUser = ({ uuid, options }: { uuid: string; options?: Record<string, boolean | number> }) => {
  return useGenericQuery<{ accessToken: string; refreshToken: string }, RequestError>(
    [QUERY_KEYS.changeUser],
    () => changeUser(uuid),
    {
      ...options,
      enabled: !!uuid && !!options?.enabled,
    }
  );
};
